export const fashionEcommerceGallery = [
  {
    src: "assets/fashion/FashionEcommerceGallery10.jpg",
    alt: "Detalle de bolsillo"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery1.jpg",
    alt: "Fotografía blanco y negro"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery7.jpg",
    alt: "Plano completo modelo"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery4.jpg",
    alt: "Detalle vestuario"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery9.jpg",
    alt: "Modelo marca de ropa"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery6.jpg",
    alt: "Detalle en forma de vestuario"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery5.jpg",
    alt: "Primer plano modelo"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery2.jpg",
    alt: "Modelo con producto"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery11.jpg",
    alt: "Modelo de ropa deportiva posando"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery3.jpg",
    alt: "Modelo ropa deportiva"
  },
  {
    src: "assets/fashion/FashionEcommerceGallery8.jpg",
    alt: "Foto frontal modelo"
  }
];
